import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Filter, FilterType } from '../filter.model'

@Component({
  selector: 'a2mat-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss']
})

export class a2MatFilterDialog implements OnInit {
  FilterType = FilterType;
  isPersonalizable = false;
  filter;

  public selection;
  public selected = '===';

  filterForm = new UntypedFormGroup({
  })

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Filter,
    private matDialogRef: MatDialogRef < any > ,
  ) { }

  ngOnInit(): void {
    this.filter = this.data as Filter;
    this.selected = (this.filter.selected && this.filter.selected['op']) ? this.filter.selected['op']:this.selected;
  }

  onFilterChange(filter){
    filter.selected.op = this.selected;
    if(filter.selected.op === '!=='){
      filter.selected.display = filter.selected.display.replace(':',' !:')
    }
    this.matDialogRef.close(filter)
  }

}
